import { render, staticRenderFns } from "./ChooseItem.vue?vue&type=template&id=54593848&scoped=true"
import script from "./ChooseItem.vue?vue&type=script&lang=js"
export * from "./ChooseItem.vue?vue&type=script&lang=js"
import style0 from "./ChooseItem.vue?vue&type=style&index=0&id=54593848&prod&lang=scss&scoped=true"
import style1 from "./ChooseItem.vue?vue&type=style&index=1&id=54593848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54593848",
  null
  
)

export default component.exports